exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkout-price-bottom .checkout-price .checkout__item:last-child {\n  margin-right: 0 !important;\n}", ""]);

// exports
